import React from 'react';
import MultipeOptionQuestion from './QuestionsTypes/MultipleOptionQuestion';
import OpenQuestion from './QuestionsTypes/OpenQuestion';
import MultipleAnswerQuestion from './QuestionsTypes/MultipleAnswerQuestion';
import BoolQuestionWithDetail from './QuestionsTypes/BoolQuestionWithDetail';
import SelectQuestion from './QuestionsTypes/SelectQuestion';
import Parse from 'parse';
import { GetQuestionsConfiguration } from './Configuration/QuestionConfiguration';
import TinyLoader from './../../Components/Loader/TinyLoader';
import {Admin} from './../../../configurations/Admin';



class MedicalHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: GetQuestionsConfiguration(),
      patient: props.patient,
      loading:false,
      isError:false,
      attendanceReason: null, regularMedicine: null, systematicPathology:null, 
      hasOrthodontics: null, isInTreatment:null, hasTeethSore:null, hasBridges:null,
      regularMedicineDetail:null,
      systematicPathologyDetail:null,
      hasOrthodonticsDetail:null,
      isInTreatmentDetail:null,
      hasBridgesDetail:null,
      attendanceReasonErrors:[],
      regularMedicineErrors:[],
      systematicPathologyErrors:[],
      hasOrthodonticsErrors:[],
      isInTreatmentErrors:[],
      hasTeethSoreErrors:[],
      hasBridgesErrors:[]
    }
  }

  componentDidMount = () => {
    this.updateQuestionsWithPatientData(this.props.patient);
    this.setState({patient: this.props.patient});
  }

  validateField = async (field, questions, rules) => {
    let question = questions[field];
    if(rules.includes("empty")){
      if(question.value === ""){
        question.isError = true;
        question.errors=[];
        question.errors.push("Este campo es obligatorio");
        questions[field]=question;
        this.setState({questions: questions});
        return true;
      }
    }

    question.isError = false;
    question.errors=[];
    return false;
  }

  countErrorsAndValidateFields = async () => {
    let errorsCounter = 0;
    const {attendanceReason,regularMedicine,systematicPathology,hasOrthodontics,isInTreatment,hasTeethSore,hasBridges,
      regularMedicineDetail,systematicPathologyDetail,hasOrthodonticsDetail,isInTreatmentDetail,hasBridgesDetail} = this.state;


    this.setState({
      attendanceReasonErrors:[],
      regularMedicineErrors:[],
      systematicPathologyErrors:[],
      hasOrthodonticsErrors:[],
      isInTreatmentErrors:[],
      hasTeethSoreErrors:[],
      hasBridgesErrors:[]
    });

    if(typeof attendanceReason === "undefined" || attendanceReason === null || attendanceReason === ""){
      this.setState({attendanceReasonErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof regularMedicine === "undefined" || regularMedicine === null || regularMedicine === ""){
      this.setState({regularMedicineErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof systematicPathology === "undefined" || systematicPathology === null || systematicPathology === ""){
      this.setState({systematicPathologyErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof hasOrthodontics === "undefined" || hasOrthodontics === null || hasOrthodontics === ""){
      this.setState({hasOrthodonticsErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof isInTreatment === "undefined" || isInTreatment === null || isInTreatment === ""){
      this.setState({isInTreatmentErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof hasTeethSore === "undefined" || hasTeethSore === null || hasTeethSore === ""){
      this.setState({hasTeethSoreErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof hasBridges === "undefined" || hasBridges === null || hasBridges === ""){
      this.setState({hasBridgesErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(typeof hasTeethSore === "undefined" || hasTeethSore === null || hasTeethSore === ""){
      this.setState({hasTeethSoreErrors: ["Esta pregunta es obligatoria"]});
      errorsCounter += 1;
    }

    if(regularMedicine){
      if(!regularMedicineDetail || regularMedicineDetail === null || regularMedicineDetail === ""){
        this.setState({regularMedicineErrors: ["Debes especificar esta pregunta"]});
        errorsCounter += 1;
      }
    }

    if(systematicPathology){
      if(!systematicPathologyDetail || systematicPathologyDetail === null || systematicPathologyDetail === ""){
        this.setState({systematicPathologyErrors: ["Debes especificar esta pregunta"]});
        errorsCounter += 1;
      }
    }

    if(hasOrthodontics){
      if(!hasOrthodonticsDetail || hasOrthodonticsDetail === null || hasOrthodonticsDetail === ""){
        this.setState({hasOrthodonticsErrors: ["Debes especificar esta pregunta"]});
        errorsCounter += 1;
      }
    }

    if(isInTreatment){
      if(!isInTreatmentDetail || isInTreatmentDetail === null || isInTreatmentDetail === ""){
        this.setState({isInTreatmentErrors: ["Debes especificar esta pregunta"]});
        errorsCounter += 1;
      }
    }

    if(hasBridges){
      if(!hasBridgesDetail || hasBridgesDetail === null || hasBridgesDetail === ""){
        this.setState({hasBridgesErrors: ["Debes especificar esta pregunta"]});
        errorsCounter += 1;
      }
    }

    return errorsCounter;
  }

  onSave = async () => {
    let currentUser = Parse.User.current();
    if(currentUser.get("username") === Admin.user_admin){
      this.setState({isError:true});
      return;
    }
    

    let errorsCounter = await this.countErrorsAndValidateFields();
    
    if(errorsCounter > 0){
      this.setState({isError:true});
      return;
    }
    this.setState({isError:false});


    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);
    const {patient} = this.props;
    const {attendanceReason,regularMedicine,systematicPathology,hasOrthodontics,isInTreatment,hasTeethSore,hasBridges,
      regularMedicineDetail,systematicPathologyDetail,hasOrthodonticsDetail,isInTreatmentDetail,hasBridgesDetail
    } = this.state;
    let patientFounded = await query.get(patient.id);
    //TODO: Validar existencia
    patientFounded.set("attendanceReason", attendanceReason);
    patientFounded.set("regularMedicine", regularMedicine);
    patientFounded.set("systematicPathology", systematicPathology);
    patientFounded.set("hasOrthodontics", hasOrthodontics);
    patientFounded.set("isInTreatment", isInTreatment);
    patientFounded.set("hasTeethSore", hasTeethSore);
    patientFounded.set("isInTreatment", isInTreatment);
    patientFounded.set("hasBridges", hasBridges);
    patientFounded.set("regularMedicineDetail", regularMedicine? regularMedicineDetail: "");
    patientFounded.set("systematicPathologyDetail", systematicPathology? systematicPathologyDetail: "");
    patientFounded.set("hasOrthodonticsDetail", hasOrthodontics? hasOrthodonticsDetail: "");
    patientFounded.set("isInTreatmentDetail", isInTreatment? isInTreatmentDetail: "");
    patientFounded.set("hasBridgesDetail", hasBridges? hasBridgesDetail: "");

    // //TODO: Controlar errores, mostrar loaders

    this.setState({loading:true});
    await patientFounded.save();
    this.setState({loading:false});
  }

  handleChangeListener = (field, value) => {
    if(field === "attendanceReason") this.setState({attendanceReason:value, attendanceReasonErrors:[]}); 
    if(field === "regularMedicine") this.setState({regularMedicine:value, regularMedicineErrors:[]}); 
    if(field === "systematicPathology") this.setState({systematicPathology:value, systematicPathologyErrors:[]});  
    if(field === "hasOrthodontics") this.setState({hasOrthodontics:value, hasOrthodonticsErrors:[]});  
    if(field === "isInTreatment") this.setState({isInTreatment:value, isInTreatmentErrors:[]}); 
    if(field === "hasTeethSore") this.setState({hasTeethSore:value, hasTeethSoreErrors:[]}); 
    if(field === "hasBridges") this.setState({hasBridges:value, hasBridgesErrors:[]});
    if(field === "regularMedicineDetail") this.setState({regularMedicineDetail:value, regularMedicineErrors:[]});
    if(field === "systematicPathologyDetail") this.setState({systematicPathologyDetail:value, systematicPathologyErrors:[]});
    if(field === "hasOrthodonticsDetail") this.setState({hasOrthodonticsDetail:value, hasOrthodonticsErrors:[]});
    if(field === "isInTreatmentDetail") this.setState({isInTreatmentDetail:value, isInTreatmentErrors:[]});
    if(field === "hasBridgesDetail") this.setState({hasBridgesDetail:value, hasBridgesErrors:[]});
  }

  updateQuestionsWithPatientData = (patient) => {
    if(patient === null || patient.id === 0){
      return;
    }
    
    this.setState({
      attendanceReason: patient.get("attendanceReason"), 
      regularMedicine: patient.get("regularMedicine"), 
      systematicPathology:patient.get("systematicPathology"), 
      hasOrthodontics: patient.get("hasOrthodontics"), 
      isInTreatment:patient.get("isInTreatment"), 
      hasTeethSore:patient.get("hasTeethSore"), 
      hasBridges:patient.get("hasBridges"),
      regularMedicineDetail:patient.get("regularMedicineDetail"),
      systematicPathologyDetail:patient.get("systematicPathologyDetail"),
      hasOrthodonticsDetail:patient.get("hasOrthodonticsDetail"),
      isInTreatmentDetail:patient.get("isInTreatmentDetail"),
      hasBridgesDetail:patient.get("hasBridgesDetail"),
    });
  }

  render() {
    const {attendanceReason, regularMedicine, systematicPathology, 
          hasOrthodontics, isInTreatment, hasTeethSore, hasBridges,
          regularMedicineDetail,
          systematicPathologyDetail,
          hasOrthodonticsDetail,
          isInTreatmentDetail,
          hasBridgesDetail,
          attendanceReasonErrors,
          regularMedicineErrors,
          systematicPathologyErrors,
          hasOrthodonticsErrors,
          isInTreatmentErrors,
          hasTeethSoreErrors,
          hasBridgesErrors
    } = this.state;

    const {patient} = this.state;
    if(patient === null){
      return <p>Usuario inválido</p>
    }else{
      if(!patient){
        return <p>cargando...</p>
      }
    }


    const loading = this.state.loading ? <TinyLoader/> : null;

    let errorOnForm = null;
    if(this.state.isError){
      errorOnForm = <p className="error text-center">Existen algunos errores en el formulario</p>
    }

    return(
    <div>
      <div className="vertical-separator-20px"></div> 

      <h3>HISTORIAL MÉDICO</h3>
        <span className="error">*Todos los campos son obligatorios</span>
        <div className="vertical-separator-10px"></div> 

        <SelectQuestion
          field={this.state.questions["attendanceReason"].field}
          text={this.state.questions["attendanceReason"].text}
          note={this.state.questions["attendanceReason"].note}
          options={this.state.questions["attendanceReason"].options}
          predefinedValue={attendanceReason}
          predefinedOtherValue={this.state.questions["attendanceReason"].predefinedOtherValue}
          placeHolder={this.state.questions["attendanceReason"].placeHolder}
          rules={this.state.questions["attendanceReason"].rules}
          type={this.state.questions["attendanceReason"].type}
          value={attendanceReason}
          otherValue={this.state.questions["attendanceReason"].otherValue}
          isError={attendanceReasonErrors.length > 0}
          errors={attendanceReasonErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["attendanceReason"].otherText}
          valueForOther={true}
        />

        <div className="vertical-separator-10px"></div> 

        <BoolQuestionWithDetail 
          field={this.state.questions["regularMedicine"].field}
          text={this.state.questions["regularMedicine"].text}
          note={this.state.questions["regularMedicine"].note}
          options={this.state.questions["regularMedicine"].options}
          predefinedValue={regularMedicine}
          predefinedOtherValue={this.state.questions["regularMedicine"].predefinedOtherValue}
          placeHolder={this.state.questions["regularMedicine"].placeHolder}
          rules={this.state.questions["regularMedicine"].rules}
          type={this.state.questions["regularMedicine"].type}
          value={regularMedicine}
          otherValue={regularMedicineDetail}
          isError={regularMedicineErrors.length > 0}
          errors={regularMedicineErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["regularMedicine"].otherText}
          valueForOther={true}
          otherField="regularMedicineDetail"
        />

        <div className="vertical-separator-20px"></div>

        <BoolQuestionWithDetail 
          field={this.state.questions["systematicPathology"].field}
          text={this.state.questions["systematicPathology"].text}
          note={this.state.questions["systematicPathology"].note}
          options={this.state.questions["systematicPathology"].options}
          predefinedValue={systematicPathology}
          predefinedOtherValue={this.state.questions["systematicPathology"].predefinedOtherValue}
          placeHolder={this.state.questions["systematicPathology"].placeHolder}
          rules={this.state.questions["systematicPathology"].rules}
          type={this.state.questions["systematicPathology"].type}
          value={systematicPathology}
          otherValue={systematicPathologyDetail}
          isError={systematicPathologyErrors.length > 0}
          errors={systematicPathologyErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["systematicPathology"].otherText}
          valueForOther={true}
          otherField="systematicPathologyDetail"

        />

        <div className="vertical-separator-20px"></div> 

        <BoolQuestionWithDetail 
          field={this.state.questions["hasOrthodontics"].field}
          text={this.state.questions["hasOrthodontics"].text}
          note={this.state.questions["hasOrthodontics"].note}
          options={this.state.questions["hasOrthodontics"].options}
          predefinedValue={hasOrthodontics}
          predefinedOtherValue={this.state.questions["hasOrthodontics"].predefinedOtherValue}
          placeHolder={this.state.questions["hasOrthodontics"].placeHolder}
          rules={this.state.questions["hasOrthodontics"].rules}
          type={this.state.questions["hasOrthodontics"].type}
          value={hasOrthodontics}
          otherValue={hasOrthodonticsDetail}
          isError={hasOrthodonticsErrors.length > 0}
          errors={hasOrthodonticsErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["hasOrthodontics"].otherText}
          valueForOther={true}
          otherField="hasOrthodonticsDetail"

        />

        <div className="vertical-separator-20px"></div> 

        <BoolQuestionWithDetail 
          field={this.state.questions["isInTreatment"].field}
          text={this.state.questions["isInTreatment"].text}
          note={this.state.questions["isInTreatment"].note}
          options={this.state.questions["isInTreatment"].options}
          predefinedValue={isInTreatment}
          predefinedOtherValue={this.state.questions["isInTreatment"].predefinedOtherValue}
          placeHolder={this.state.questions["isInTreatment"].placeHolder}
          rules={this.state.questions["isInTreatment"].rules}
          type={this.state.questions["isInTreatment"].type}
          value={isInTreatment}
          otherValue={isInTreatmentDetail}
          isError={isInTreatmentErrors.length > 0}
          errors={isInTreatmentErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["isInTreatment"].otherText}
          valueForOther={true}
          otherField="isInTreatmentDetail"

        />

        <div className="vertical-separator-20px"></div> 

        <SelectQuestion
          field={this.state.questions["hasTeethSore"].field}
          text={this.state.questions["hasTeethSore"].text}
          note={this.state.questions["hasTeethSore"].note}
          options={this.state.questions["hasTeethSore"].options}
          predefinedValue={hasTeethSore}
          predefinedOtherValue={this.state.questions["hasTeethSore"].predefinedOtherValue}
          placeHolder={this.state.questions["hasTeethSore"].placeHolder}
          rules={this.state.questions["hasTeethSore"].rules}
          type={this.state.questions["hasTeethSore"].type}
          value={hasTeethSore}
          otherValue={this.state.questions["hasTeethSore"].otherValue}
          isError={hasTeethSoreErrors.length > 0}
          errors={hasTeethSoreErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["hasTeethSore"].otherText}
          valueForOther={this.state.questions["hasTeethSore"].valueForOther}
        />

        <div className="vertical-separator-20px"></div> 

        <BoolQuestionWithDetail 
          field={this.state.questions["hasBridges"].field}
          text={this.state.questions["hasBridges"].text}
          note={this.state.questions["hasBridges"].note}
          options={this.state.questions["hasBridges"].options}
          predefinedValue={hasBridges}
          predefinedOtherValue={this.state.questions["hasBridges"].predefinedOtherValue}
          placeHolder={this.state.questions["hasBridges"].placeHolder}
          rules={this.state.questions["hasBridges"].rules}
          type={this.state.questions["hasBridges"].type}
          value={hasBridges}
          otherValue={hasBridgesDetail}
          isError={hasBridgesErrors.length > 0}
          errors={hasBridgesErrors}
          handleChangeListener={this.handleChangeListener}
          otherText={this.state.questions["hasBridges"].otherText}
          valueForOther={true}
          otherField="hasBridgesDetail"

        />

        <div className="vertical-separator-20px"></div> 


        <div className="row justify-content-center">
          <div className="col-md-4 col-md-offset-4">
            {errorOnForm}
            <button
              className="button-outlined"
              onClick={this.onSave}
              >
              Guardar
            </button>
          </div>
          <div className="col-md-1">
            <div className="vertical-separator-10px"></div> 
            {loading}
          </div>
        </div>

        <div className="vertical-separator-30px"></div> 



      </div>
    );
  }
}

export default MedicalHistory;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/MedicalHistory.js